export const themeOptions = {
    palette: {
        primary: {
            main: '#0075BE',
            contrastText: '#fff',
        },
        text: {
            primary: '#313c45',
        },
    },
}
